import {type RefObject, useCallback, useRef} from "react";
import {noop} from "app/utils/types";
import {useAsync} from "@fluentui/react-hooks";
import type {WatchAgain, WatchCurrent, WatchSegment} from "app/employee/video/VideoPlayer";
import {isNil} from "app/utils/stdlib";
import type {ShakaHandle} from "app/employee/video/ShakaPlayer";

export const useProgressCallback = (
  playerRef: RefObject<ShakaHandle>,
  playerControl: WatchAgain | WatchCurrent | WatchSegment
) => {
  const updateProgressRef = useRef<() => void>(noop);
  const updateProgressThrottledRef = useRef<() => void>(noop);
  const async = useAsync();

  updateProgressRef.current = useCallback(() => {
    if (playerRef.current && playerControl.type === "current") {
      const currentTimeSec = playerRef.current?.currentTime();
      if (!isNil(currentTimeSec)) {
        console.log("updateProgress", currentTimeSec.toFormat("hh:mm:ss.SSS"));
        playerControl.updateProgress(currentTimeSec);
      }
    }
  }, [playerControl, playerRef]);

  updateProgressThrottledRef.current = async.throttle(updateProgressRef.current, 5000, {
    leading: false,
    trailing: true
  });

  const updateProgress = useCallback(() => updateProgressRef.current(), []);
  const updateProgressThrottled = useCallback(() => updateProgressThrottledRef.current(), []);
  return {
    updateProgress,
    updateProgressThrottled
  };
};
